<form (ngSubmit)="submitNote()">
  <div id="managerInstructionWrapper" class="child-component">
    <div class="tab-header-section pt-2 pb-4 px-3">
      <div class="row">
        <div class="col-md-12">
          <label for="managerInstruction" class="form-label">Manager Notes*</label>
          <input id="managerInstruction" type="text" name="managerNote" [(ngModel)]="managerNote" required
            class="form-control" />
        </div>
      </div>
    </div>

    <ng-template #managerNotesFooter>
      <button type="submit" class="pn-button pn-button-primary pn-button-md" (click)="submitNote()" [disabled]="!managerNote?.trim()">Update</button>
      <button type="button" class="pn-button pn-button-tertiary pn-button-md" (click)="cancel()">Cancel</button>
    </ng-template>
    
  </div>
</form>